import toast, { Toast, ToastOptions } from "react-hot-toast";
import MessageBanner, {
  MessageType,
} from "components/elements/MessageBanner/MessageBanner";
import { AnimatePresence, motion } from "motion/react";

export const popToast = (
  render: (toast?: Toast) => React.JSX.Element,
  options?: ToastOptions,
) =>
  toast.custom((toast: Toast) => render(toast), {
    position: "top-center",
    ...options,
  });

export const dismissToast = (toastId: string) => toast.dismiss(toastId);

export const popToastInfo = (text: string, options?: ToastOptions) =>
  popToast(
    (toast) => (
      <AnimatePresence>
        {toast.visible && (
          <motion.div
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            transition={{ duration: 1.5, type: "spring" }}
            exit={{ y: -100 }}
          >
            <div className="mt-[3px] flex h-[42px] ">
              <MessageBanner messageType={MessageType.Info} colourWidth="sm">
                <p className=" text-sm">{text}</p>
              </MessageBanner>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    ),
    options,
  );

export const popToastSuccess = (text: string) => {
  popToast((toast) => (
    <AnimatePresence>
      {toast.visible && (
        <motion.div
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          transition={{ duration: 1.5, type: "spring" }}
          exit={{ y: -100 }}
        >
          <div className="mt-[3px] flex h-[42px] ">
            <MessageBanner messageType={MessageType.Success} colourWidth="sm">
              <p className=" text-sm">{text}</p>
            </MessageBanner>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  ));
};

export const popToastError = (text: string) => {
  popToast((toast) => (
    <AnimatePresence>
      {toast.visible && (
        <motion.div
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          transition={{ duration: 1.5, type: "spring" }}
          exit={{ y: -100 }}
        >
          <div className="mt-[3px] flex h-[42px] ">
            <MessageBanner messageType={MessageType.Error} colourWidth="sm">
              <p className=" text-sm">{text}</p>
            </MessageBanner>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  ));
};
